import { memo } from 'react';

import Button from '@/shared/components/button/Button';

import type { Direction } from '@/features/letterParty/types';

export type MovementButtonMode = 'change-on-click' | 'hold-to-move';

interface MovementButtonsProps {
	mode?: MovementButtonMode;
	onDirectionChange: (direction: Direction) => void;
	onMovementStop: () => void;
}

const MOVEMENT_BUTTONS: Array<{ direction: Direction; icon: string }> = [
	{ direction: 'DOWN', icon: 'icon-arrow-down' },
	{ direction: 'LEFT', icon: 'icon-arrow-left' },
	{ direction: 'RIGHT', icon: 'icon-arrow-right' },
	{ direction: 'UP', icon: 'icon-arrow-up' },
];

const MovementButtons = ({ mode = 'hold-to-move', onDirectionChange, onMovementStop }: MovementButtonsProps) => {
	const handlePointerDown = (direction: Direction) => {
		onDirectionChange(direction);
	};

	const handlePointerUp = () => {
		if (mode === 'hold-to-move') {
			onMovementStop();
		}
	};

	return (
		<div className="letter-party-game__movement-buttons">
			{MOVEMENT_BUTTONS.map(({ direction, icon }) => {
				return (
					<Button
						key={direction}
						btnType="button"
						type="primary"
						className={`movement-button ${direction.toLowerCase()}`}
						iconName={icon}
						onPointerDown={() => handlePointerDown(direction)}
						onPointerUp={handlePointerUp}
						tabIndex={0}
					/>
				);
			})}
		</div>
	);
};

export default memo(MovementButtons);
